/** Languages that have translation files. */
export const SUPPORTED_LANGS: readonly string[] = ['en', 'es', 'ca', 'it'];

/** Used when no browser language is supported, and for keys missing in the current language. */
export const FALLBACK_LANG = 'en';

/** Name of each supported language in that language, so it is recognisable whatever the current one is. */
export const LANG_NATIVE_NAMES: Readonly<Record<string, string>> = {
  en: 'English',
  es: 'Español',
  ca: 'Català',
  it: 'Italiano',
};
